import { render, staticRenderFns } from "./sample-policy.vue?vue&type=template&id=45b8aef6"
import script from "./sample-policy.vue?vue&type=script&lang=js"
export * from "./sample-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports